<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="themes"
    multiple
    small-chips
    deletable-chips
    :data-testid="dataTestid"
  />
</template>

<script>
import { themesDuDomaine } from "./domaine";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    domaine: {
      type: Array,
      required: false,
    },
  },

  computed: {
    themes() {
      return [
        ...themesDuDomaine(this.domaine).concat(this.$attrs.value),
      ];
    },
  },
};
</script>
